export const BscRTravaConfig = {
  incentiveAddress: "0x4c481E66798c6C82aF77d1e14d3233fE5D592A0b",
  tokenList: [
    "0x17335Ff98BebA2E36D11421d4bD613C24B61ACbE",
    "0x686D48359fE4a3b1aa106E03407fE17CD2e76Cb9",
    "0xa089EeaD5249362c9BA88E477866616BCF8Ef78D",
    "0xbC4c781A0ED730D0Adb3c9170335ebEb7cb5d93c",
    "0x456f85BA534311867678128c1278Be2484Adfb3d",
    "0xEaAd201328f1e3dc1b21D736C3a1A558b1bD118B",
    "0x0A71819048aAa71A8A2FA0A4313F1F0c973c1d4b",
    "0x86cfb905319371AA3B8989fFEa7BeBb607c07c86",
    "0x81A82D5e48e776Fb6D75A724944007c199F87642",
    "0x77035788B48fa508548D7985263C9ad094defa8F",
    "0xDD7374c06582DfD7660471296806507c2d7D72F4",
    "0x1d902fb6fA351F1E9713e79BDC4B7BB2aCAffA04",
    "0x9Ba759a0b4C6432CEB124F8979bC8CbF9171b9DA",
    "0xcE33D4F3253c1f8347d472Dfa8BA99c7fFa6507F",
    "0xFa0BE8c6dd8bc5d44C54Ba538D360380f949d0dF",
    "0x49F5BD4441c40F7800C4a63d3Fa7EE33a009D63E",
    "0x5A4CA22d522BEb6A94a374853d1b9DD35D251C43",
    "0x3ba8bbD2f716201728EeDA07517d93E497D29637",
    "0xbb0f92cc25d5748F076f067b5D853dd34BDE51B1",
    "0xC4038D1Fbf3C3dEF7B74c30df6520eaD642945bE",
    "0x8c9dA1612b2830DB7322E4240D515E3a26af27E9",
    "0xB755a210F9385ef74b2D3546427D97FD5594D1BC",
    "0x225f74A249E1E16f77d7D013bA4C1aF02d8C8302",
    "0x340F43BF0Be85a3F107b00DF669cc9aa99354281",
    "0x0B34adFe9182A7Bd2147E42e50080CDDB487b1DA",
    "0x3639c0B519476295B12F6B3B0D4878fd61603441",
    "0xD1f1642cC1D9564751d12AB9e17fc58D935AdfD0",
    "0xc681d8bdAA06cACeFB8Dfb7DBF925B0F21cE45Db",
  ],
};

export const FtmRTravaConfig = {
  incentiveAddress: "0x9660f97F5a4898a0b0aBB4369e925131734c9C0D",
  tokenList: [
    "0xb80A70e0BF4D60F80b58103054ada2439335796d",
    "0x5b506313adAF754ec99bA0C9fE051480a168d96E",
    "0xc3df2327B31E5C67FE7a33c23E3eBbb6aa1A29cB",
    "0xe71940dF82aF88FACEE34284bF11CC5EEB7f5f95",
    "0xb1931dd5305D6DE19871DCD9D00947d6450fe2FF",
    "0xecC88479c8DC657AFAFe34860d71efcDc9678672",
    "0xDA38eDe6826882512d6250401E08ff73135B2F00",
    "0x905da7783F8CD5148795C9c3eca0A07bd867be1D",
    "0xfB72CdAA7CffaC7c89477bBbE6b3A494f6635A0F",
    "0x2FeAabF5c99262eD23417b3dFcC8532e3a8a379c",
    "0xC2035732E75cF8761e39232a12De4Fa170CEd607",
    "0xf238038617D111d4dE6228C35a5341Ef870AF280",
  ],
};

export const EthRTravaConfig = {
  incentiveAddress: "0x43CF9Fb8cf26E46890D6E3a4e6494A843bbb6615",
  tokenList: [
    "0x9Ba5F8d3343Cb2555a81b1d6caEE25Be10526540",
    "0x26F748C98aBa63b3EA59527ba2Bab45bAE28f6ae",
    "0x09f5bED4cdB661df0791870AcD293Fdee85950C1",
    "0x1a72EBdaE2B541f7051acf848D27BFE867569E1B",
    "0x74bB1a9A8e2E5AD14ED2a76B3e7160D81ccE3988",
    "0xF960570f53D98AC285c4ce81467cBf903c50Fa35",
    "0x5026b7F2167Bb99E093E89D23635509533a9107b",
    "0x06C492A57612073E90a32c5C389F00a4f8aFb566",
    "0x61474bdAc2c72FE5b6260A4037D45A0E88813708",
    "0x6C1Bb5df7b08EAAb17C0fAFEb9EF9d6F97D867Fd",
  ],
};

export const BscTravaConfig = {
  travaAddress: "0x0391bE54E72F7e001f6BBc331777710b4f2999Ef",
  sTravaAddress: "0xC5f0137ce42437d8f5eF25DA110F7FD7386178ec",
};

export const FtmTravaConfig = {
  travaAddress: "0x477a9D5dF9bedA06F6b021136a2efe7BE242fCC9",
  sTravaAddress: "0x182D67287fda8A7248851AC657e74D5A048310Ae",
};

export const EthTravaConfig = {
  travaAddress: "0x186D0Ba3dfC3386C464eECd96A61fBB1E2dA00bf",
  sTravaAddress: "0x84D92a3D61Ec158dCf878ff24EbDcf6b2b5ec1Fa",
};

export const NftBalanceConfig = [
  "0xF328B2a5Bb7684372C9D6a2Bcb89D2be426bC152",
  "0xD8098C35E91C3346f463582bf571ADC983fEF3D0",
  "0xcb7cff1191E3f9DF46ba1C9D36C7fb6EEaE55d0e",
  "0xCf64493616c2DeBF81bE6791260d483864E69b1F",
  "0x53931DcF18912C2D2b1232c3F47fe42ACaABb32a",
];
